// Rotates announcement slides one at a time; pauses on hover or focus and when motion is reduced.
class AnnouncementsElement extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.index = 0;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.interval = Number(this.dataset.interval) || 6000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.go(this.index + 1);
      if (event.command === '--previous') this.go(this.index - 1);
      this.restart();
    }, { signal });
    this.addEventListener('mouseenter', () => this.stop(), { signal });
    this.addEventListener('mouseleave', () => this.restart(), { signal });
    this.addEventListener('focusin', () => this.stop(), { signal });
    this.addEventListener('focusout', () => this.restart(), { signal });

    this.go(0);
    this.restart();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.stop();
  }

  go(next) {
    if (this.slides.length === 0) return;
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.toggleAttribute('data-active', active);
      slide.toggleAttribute('inert', !active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    if (this.reducedMotion || this.slides.length < 2) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.interval);
  }
}

if (!customElements.get('s-announcements')) {
  customElements.define('s-announcements', AnnouncementsElement);
}
